import script from "./hc-superadmin-login.vue?vue&type=script&setup=true&lang=js"
export * from "./hc-superadmin-login.vue?vue&type=script&setup=true&lang=js"

import "./hc-superadmin-login.vue?vue&type=style&index=0&id=76859cfe&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76859cfe"]])

export default __exports__